import { LocalStorage } from "../models/LocalStorage";
import { DEFAULT_COUNTRY, DEFAULT_CURRENCY, DEFAULT_IP_CONFIG } from "./constant";
import { Countries } from "./countries";
import { changeQueryString, getParamUrl, historyPushState } from "./url";

const COUNTRY_EMPTY = { "code": "", "iso2": "", "iso3": "", "name": "", "name_vi": "", "flag": "", "lang": "", "currency_code": "" };
export function getCountry(countryCode = "") {
  return Countries.data.find(country => country.iso2 === countryCode) || COUNTRY_EMPTY;
}

/**
 * @returns {{ value: String, label: String, label_vi: String, icon: String, iconActive: String, row: number, col: number, noCompactSvg: boolean }}
 */
export function convertShippingList(list, currentShip) {
  let result = [], sortedList = [];
  if (Array.isArray(list) && list.length > 0) {
    if (currentShip) {
      sortedList[0] = currentShip;
      list.forEach(element => {
        if (element !== currentShip) sortedList.push(element);
      });
    } else {
      sortedList = list;
    }
    let tempList = [], flagImage = require("../assets/images/flags/flags.svg");
    sortedList.forEach(item => {
      let ship = (item || "").toUpperCase();
      let country = Countries.data.find(country => country.iso2 === ship);
      if (country?.name) {
        tempList.push({
          value: ship,
          label: country?.name || "",
          label_vi: country?.name_vi || "",
          icon: flagImage,
          row: country.row || 0,
          col: country.col || 0,
        })
      }
    })
    result = tempList;
  }
  return result;
}


export function getCurrencyCodeByCountry(countryCode = "") {
  if (!countryCode) return "";
  let country = getCountry(countryCode);
  return country.currency_code || "";
}

export function getShippingLabel(source = "") {
  const shipping = Countries.data.find(country => country.iso2 === source);
  const defaultShipping = Countries.data.find(country => country.iso2 === DEFAULT_COUNTRY).name;
  return (LocalStorage.getLanguage() === "vi" && shipping?.name_vi ? shipping.name_vi : shipping?.name) || defaultShipping;
}

export function getNamesCountry() {
  let result = {};
  Countries.data.forEach((country => {
    result[country.iso2] = {
      "name": country.name,
      "name_vi": country.name_vi
    }
  }));
  return result;
}

export function getCountryVN() {
  const VNCode = "VN";
  return getCountry(VNCode);
}

export function getDefaultShipping(shippingCountry, shippingList) {
  let paramShip = getParamUrl("sc");
  if (paramShip) {
    const url = changeQueryString("sc", undefined);
    historyPushState(url, true);
  }
  let sc = paramShip || shippingCountry || LocalStorage.getShipping();
  return validItemInList(sc, shippingList) ? sc : DEFAULT_COUNTRY;
}


export function getDefaultCurrency(currency, currencyList, country) {
  let paramCur = getParamUrl("cur");
  if (paramCur) {
    const url = changeQueryString("cur", undefined);
    historyPushState(url, true);
  }
  let cur = paramCur || currency || LocalStorage.getCurrency();
  if (validItemInList(cur, currencyList)) {
    return cur;
  } else {
    return getCurrencyCodeByCountry(country) || DEFAULT_IP_CONFIG[country]?.CURRENCY || DEFAULT_CURRENCY;
  }
}

export function getDefaultLanguage(language, country) {
  let lc = getParamUrl("hl") || language || LocalStorage.getLanguage() || DEFAULT_IP_CONFIG[country]?.LOCALE || "en";
  return lc;
}

function validItemInList(item, listItem = []) {
  if (!item || typeof (item) !== "string" || !listItem.length) return false;
  const set = new Set(listItem);

  return set.has(item.toUpperCase());
}